import { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { withTranslation } from 'react-i18next'

import Icon from '../Icons'
import { getTrainingType } from '../../helpers/helpers'
import { AgendaReservationTimeBlockItem } from './TimeBlocks/AgentaReservationTimeBlockItem'

class AgendaEvent extends Component {
  render() {
    const { t } = this.props
    const {
      date,
      type,
      type: { color, icon } = {},
      mainClient,
      trainerId: trainer,
      name,
      client,
      locationName,
      amenity,
      reservationType,
    } = this.props.event

    const eventRow = (
      <p>
        <strong>{name}</strong> {type && ` - ${type.name}`}
      </p>
    )

    const reservationRow = (
      <p>
        <strong>
          {name}
          {locationName ? ` / ${locationName}` : ''}
        </strong>{' '}
        - {client?.firstName} {client?.lastName}, {client?.unit}
      </p>
    )

    if (['timeBlock', 'reservation'].includes(reservationType)) {
      return (
        <AgendaReservationTimeBlockItem
          type={reservationType}
          timeBlockReason={this.props.event.reasonOther || this.props.event.reason}
          amenityName={this.props.event.amenityName}
          locationName={this.props.event.locationName}
          resident={this.props.event.client || this.props.event.guest}
          status={this.props.event.status}
        />
      )
    }

    return (
      <div
        className={`ctp-agenda-event ${moment(date).isBefore() ? 'ctp-agenda-event--past' : ''}`}
      >
        {icon && (
          <div className="ctp-agenda-event__icon" style={{ backgroundColor: color }}>
            <Icon icon={icon} />
          </div>
        )}
        <div>
          {amenity ? reservationRow : eventRow}
          {getTrainingType(this.props.event) === 'appointment' && (
            <div className="ctp-agenda-event__appointment">
              <p>
                <strong>{mainClient.user || ''}</strong> {t('calendar:agenda.withConnector')}{' '}
                {trainer.firstName} {trainer.lastName}
              </p>
            </div>
          )}
        </div>
      </div>
    )
  }
}

AgendaEvent.propTypes = {
  event: PropTypes.object,
  t: PropTypes.func,
}

export default withTranslation(['calendar'])(AgendaEvent)
